var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPrint = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Print_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M15.417 14.584h3.341c.459 0 .825-.392.825-.867V7.584c0-.325-.1-.65-.275-.925l-1.383-2.084H2.083L.7 6.667a1.66 1.66 0 0 0-.283.925v6.125c0 .475.375.867.825.867h3.341"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M15.416.417H4.583v4.166h10.833zM15.416 12.084H4.583v7.5h10.833zM7.083 14.584h5.833M7.083 17.084h4.167"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#888",
  d: "M14.583 8.333a.417.417 0 1 0 0-.833.417.417 0 0 0 0 .833M17.083 8.333a.417.417 0 1 0 0-.833.417.417 0 0 0 0 .833"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M2.917 12.084h14.166"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Print_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgPrint;